angular.module('BookingApp').value('AppState', {})
